export const isValidDate = (d: any) => {
  return d instanceof Date && !Number.isNaN(d.getTime());
};
